import React from 'react'
import { PortalModal } from '~/components/shared/PortalModal'

interface FeedbackPortalModalProps {
  children: React.ReactNode
  show: boolean
  onClose: () => void
}

export const FeedbackPortalModal = ({ children, show, onClose }: FeedbackPortalModalProps): JSX.Element => {
  return (
    <PortalModal
      size={'medium'}
      useMask={false}
      show={show}
      headerMarginBottom="2px"
      headerPaddingCloseButton="1.5rem 1.5rem 0 0"
      onClose={onClose}
      modalDialogProps={{ style: { padding: 0, margin: '30px auto' } }}
      modalBodyPadding="0"
      modalContainerProps={{
        style: { background: 'rgba(0, 0, 0, 0.3)' }
      }}
    >
      {children}
    </PortalModal>
  )
}
